import React, { useContext } from 'react'
import Select from '@3mcom/mds-library/dist/node/Select'

import { Translations } from '../../services/TranslationService'
import { StateContext } from '../../services/StateService'
import { trackPDPData } from '../../services/TealiumService'

/**
 * Renders a column header with an inline selector for filtering product options.
 * @param {Object} column - Column config including label, identifier, and colSelectors
 * @param {number} index - Column index used for element IDs
 */
const ProductOptionSelect = ({ column, index }) => {
    const translations = useContext(Translations)
    const { dispatch, selectedOptions } = useContext(StateContext)

    const selector = selectedOptions?.options[column.identifier]

    const onChange = (target) => {
        dispatch({
            type: 'pdp_on_change_selected_options',
            payload: {
                selector: selector,
                target: target,
                allLabel: translations.all
            }
        })
        trackPDPData(
            `PDP Product Options Selector ${selector.label} Click: ${selector.selectedValue}`,
            'Engagement Event'
        )
    }

    return (
        <>
            <div className="sps2-pdp_product-options--col-label">{column.label}</div>
            <div className="sps2-pdp_pSelector--selectors mds-margin_small--top">
                <Select
                    id={`${index}_pSelector`}
                    key={`${index}_pSelector`}
                    showFieldName={false}
                    selectLabel={translations.all}
                    disabled={selector.disabled}
                    value={selector?.selectedValue || 'all'}
                    onChange={(e) => onChange(e.target)}
                >
                    {column?.colSelectors.map((value, i) => (
                        <option
                            disabled={value?.disabled}
                            className={
                                value?.disabled
                                    ? 'sps2-pdp_pSelector--selectors_disabled'
                                    : ''
                            }
                            key={`${i}_p-value`}
                            value={value?.api}
                            // eslint-disable-next-line react/no-unknown-property
                            optionlabel={`${value?.value} ${value?.uom ? value.uom : ''}`}
                        >
                            {`${value?.value} ${value?.uom ? value.uom : ''}${
                                value?.disabled ? ` - ${translations.notApplicable}` : ''
                            }`}
                        </option>
                    ))}
                </Select>
            </div>
        </>
    )
}

export default ProductOptionSelect
